import React from 'react';
import PropTypes from 'prop-types';
import DivLayoutV2FieldGrid from './DivLayoutV2FieldGrid';
import './DivLayoutV2.css';

const DivLayoutV2SubCard = ({ badge, fields, children }) => (
  <div className="div-layout-v2-subcard">
    {badge && <span className="div-layout-v2-subcard-badge">{badge}</span>}
    {fields?.length > 0 && <DivLayoutV2FieldGrid fields={fields} />}
    {children}
  </div>
);

DivLayoutV2SubCard.propTypes = {
  badge: PropTypes.string,
  fields: PropTypes.array,
  children: PropTypes.node,
};

export default DivLayoutV2SubCard;
